/*
 * @Author: zhangsheng
 * @Date: 2025-12-19 14:36:58
 * @LastEditors: zhangsheng
 * @LastEditTime: 2025-12-23 14:44:57
 * @FilePath: \panda-index-sicermem-frontend - 副本\src\index.tsx
 * @Description: 
 * 
 * Copyright (c) 2025 by zhangsheng , All Rights Reserved. 
 */
import { createRoot } from 'react-dom/client';
import App from './App';
import 'bootstrap/dist/js/bootstrap.bundle.min'; // 包含Popper
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import './index.css';
import './i18n.js';
import React from 'react';

createRoot(document.getElementById('root')).render(<App />);
